import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Dashboardv2Component } from './dashboardv2.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: Dashboardv2Component,
        data: {
          title: "Dashboard",
          breadcrumb: "Dashboard"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Dashboardv2RoutingModule { }
